import React from 'react'
import { useTranslation } from 'react-i18next'
import { Autosuggest } from '@fs/zion-ui'
import { actions } from './useUserContributions'
import getTypeFiltersInitialState from '../../common/TypeFiltersState'

export default function UserContributionsPersonFilters({ pageState, getContributions, setTypeFiltersState }) {
  const { t } = useTranslation()
  function onChange(selectedItem, actionEnum) {
    pageState?.currentUser?.contributorId &&
      getContributions(pageState.currentUser.contributorId, null, selectedItem, null, null, actionEnum)
    setTypeFiltersState(getTypeFiltersInitialState({ t }))
  }

  return (
    <div data-testid="personFilterAutosuggest">
      <Autosuggest
        label={t('filters.filter', 'Filter')}
        selectedItem={pageState.metadata.filterSelectedItem}
        suggestions={pageState.metadata.filterSuggestions}
        onSuggestionSelected={(selectedItem) => selectedItem && onChange(selectedItem, actions.SET_FILTER)}
        onClear={() => onChange(undefined, actions.SET_CONTRIBUTIONS)}
        placeholder={t('user.filters.prompt', 'Person Id or Name')}
        highlightMatchingText
        clearable
      />
    </div>
  )
}
